import { Flex, FlexProps } from "@chakra-ui/react";
import ConditionItem from "./ConditionItem";
import { AIR_TEMPERATURE_CATEGORY, TRACK_TEMPERATURE_CATEGORY, WIND_CATEGORIES, WEATHER_CATEGORIES, ROUGHNESS_CATEGORIES, TARMAC_CONDITION_CATEGORIES } from "./enums";

type ReducedConditionsProps = {
  airTemperature: AIR_TEMPERATURE_CATEGORY;
  trackTemperature: TRACK_TEMPERATURE_CATEGORY;
  wind: WIND_CATEGORIES;
  rain: WEATHER_CATEGORIES;
  roughness: ROUGHNESS_CATEGORIES;
  tarmacCondition: TARMAC_CONDITION_CATEGORIES;
  reduced?: boolean;
  tbd?: boolean;
}
const ReducedConditions = ({
  airTemperature,
  trackTemperature,
  wind,
  rain,
  roughness,
  tarmacCondition,
  reduced = true,
  tbd = false,
  ...rest
}: ReducedConditionsProps & FlexProps) => {
  if (reduced) {
    return (
      <Flex
        gap="0.5"
        w="full"
      >
        <ConditionItem type="airTemperature" variant={airTemperature} tbd={tbd} />
        <ConditionItem type="trackTemperature" variant={trackTemperature} tbd={tbd} />
        <ConditionItem type="rain" variant={rain} tbd={tbd} />
      </Flex>
    )
  }

  return (
    <Flex
      flexDir="column"
      gap="1"
      w="full"
      {...rest}
    >
      <Flex
        gap="1"
        w="full"
      >
        <ConditionItem type="trackTemperature" variant={trackTemperature} tbd={tbd} />
        <ConditionItem type="airTemperature" variant={airTemperature} tbd={tbd} />
        <ConditionItem type="wind" variant={wind} tbd={tbd} />
      </Flex>
      <Flex
        gap="1"
        w="full"
      >
        <ConditionItem type="rain" variant={rain} tbd={tbd} />
        <ConditionItem type="tarmacCondition" variant={tarmacCondition} tbd={tbd} />
        <ConditionItem type="roughness" variant={roughness} tbd={tbd} />
      </Flex>
    </Flex>
  )
}

export default ReducedConditions;